import {Component} from '@angular/core'
// TODO [GitHub Issue] delete me
import {
  MainMenuComponent,
  SidebarComponent
} from './../'

@Component({
  selector: 'mp-navigation',
  templateUrl: './navigation.html',
  styleUrls: ['./navigation.scss'],
})
export class NavigationComponent {

  public menuNavigation = false;
  public mainMenu = false;
  public resourceMenu = false;

  showResourceMenu(): void {
    this.resourceMenu = true
    this.mainMenu = false
  }
  showMainMenu(): void {
    this.mainMenu = true
    this.resourceMenu = false
  }

  toggleMenuNavigation(): void{
    if(this.menuNavigation){
      this.hideAllMenus()
    }else{
      this.openMenuNavigation()
    }
  }

  private hideAllMenus(): void {
    this.menuNavigation = false
    this.mainMenu = false
    this.resourceMenu = false
  }

  private openMenuNavigation(): void {
    this.menuNavigation = true
    this.mainMenu = false
    this.resourceMenu = true
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/navigation/navigation.component.ts